import { Component, Input } from '@angular/core';
import { CompaniesService, CompanyMembership } from 'src/app/core/companies.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { ERROR_COMPANY_MEMBERSHIP_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-company-details-team-data',
  templateUrl: './company-details-team-data.component.html',
  styleUrls: ['./company-details-team-data.component.scss'],
})
export class CompanyDetailsTeamDataComponent {
  @Input() company_id?: string | null;
  company_membership?: CompanyMembership[];
  is_read_running = true;

  constructor(private companies_service: CompaniesService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.company_membership = [];
    if (this.company_id) this.listStores(this.company_id);
  }

  onRefresh(): void {
    this.company_membership = [];
    if (this.company_id) this.listStores(this.company_id);
  }

  listStores(company_id?: string): void {
    this.is_read_running = true;

    if (company_id) {
      this.companies_service.listCompanyMembership(company_id).subscribe({
        next: response => {
          this.company_membership = response.data;
          this.is_read_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          if (processed_error.code == ERROR_COMPANY_MEMBERSHIP_NOT_FOUND) {
            this.company_membership = [];
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_read_running = false;
        },
      });
    }
  }
}
